import { useState } from "react";

export default function SubmitChannel() {
  const [type, setType] = useState("文档");
  const [sent, setSent] = useState(false);

  return (
    <section id="submit" className="relative overflow-hidden bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          {/* 左文案 */}
          <div className="flex flex-col justify-center lg:col-span-6">
            <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.28em] text-primary-600">
              <i className="ri-speak-line" />
              Anonymous
            </span>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              匿名投稿通道
            </h2>
            <p className="mt-3 max-w-lg text-sm leading-relaxed text-secondary-600">
              你掌握的材料，值得被专业核查而不是石沉大海。留下线索，剩下的交给双重信源交叉验证。
            </p>

            <ul className="mt-7 space-y-4">
              {[
                { icon: "ri-shield-check-line", t: "端到端匿名", d: "投稿路径全部去身份化，不与稿件内容同库关联。" },
                { icon: "ri-file-search-line", t: "材料范围", d: "文档、邮件、截图、录音、财报、合同等一手证据皆可。" },
                { icon: "ri-community-line", t: "线索回报", d: "核实并发布后，按线索价值提供专属跟进与优先反馈。" },
              ].map((f) => (
                <li key={f.t} className="flex gap-3.5">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className={`${f.icon} text-lg`} />
                  </span>
                  <div>
                    <h3 className="text-sm font-bold text-foreground-900">{f.t}</h3>
                    <p className="mt-0.5 text-xs leading-relaxed text-secondary-600">{f.d}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* 右投稿卡 */}
          <div className="lg:col-span-6">
            <div className="rounded-xl border border-background-200 bg-background-100 p-6 md:p-8">
              <div className="mb-5 flex flex-wrap items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-600 text-background-50">
                  <i className="ri-lock-2-line text-sm" />
                </span>
                <p className="text-sm font-bold text-foreground-900">安全提交线索</p>
                <span className="ml-auto text-[11px] text-secondary-500">仅作演示 · 不实际接收</span>
              </div>

              <label className="mb-1.5 block text-xs font-medium text-secondary-600">
                线索主题
              </label>
              <input
                type="text"
                placeholder="用一句话概括你掌握的内幕"
                className="mb-4 w-full rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition placeholder:text-secondary-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
              />

              <label className="mb-1.5 block text-xs font-medium text-secondary-600">
                材料类型
              </label>
              <div className="mb-4 flex flex-wrap gap-2">
                {["文档", "截图", "邮件", "录音", "财务数据", "其它"].map((o) => (
                  <button
                    key={o}
                    onClick={() => setType(o)}
                    className={`rounded-full px-3 py-1.5 text-xs font-medium transition ${
                      type === o
                        ? "bg-primary-600 text-background-50"
                        : "bg-background-200 text-secondary-600 hover:bg-background-300"
                    }`}
                  >
                    {o}
                  </button>
                ))}
              </div>

              <label className="mb-1.5 block text-xs font-medium text-secondary-600">
                详细描述
              </label>
              <textarea
                rows={4}
                maxLength={500}
                placeholder="尽量提供可交叉核验的事实细节，如时间、主体、金额与相关方…"
                className="mb-4 w-full resize-none rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none transition placeholder:text-secondary-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
              />

              <button
                onClick={() => setSent(true)}
                className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-700"
              >
                {sent ? (
                  <>
                    <i className="ri-check-line" /> 线索已记录（演示）
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-line" /> 匿名提交线索
                  </>
                )}
              </button>

              <p className="mt-3 text-center text-[11px] leading-relaxed text-secondary-400">
                提交即表示知晓材料仅作核验评估使用 · 请勿提交无关个人信息
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}